import { render, staticRenderFns } from "./CustomList.vue?vue&type=template&id=6fc2e3ca&scoped=true"
import script from "./CustomList.vue?vue&type=script&lang=js"
export * from "./CustomList.vue?vue&type=script&lang=js"
import style0 from "./CustomList.vue?vue&type=style&index=0&id=6fc2e3ca&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fc2e3ca",
  null
  
)

export default component.exports